/**
 * Every English string the web app ships, merged into the one
 * `translation` namespace `src/i18n.ts` registers. Keep the spread ORDER:
 * a key that two files both define resolves to the later one.
 */
import enSharedAccountSeed from '@flashka/shared/locales/en/en-account-seed.json';
import enSharedConnection from '@flashka/shared/locales/en/en-connection.json';
import enSharedCreateMenu from '@flashka/shared/locales/en/en-create-menu.json';
import enSharedDocumentLoad from '@flashka/shared/locales/en/en-document-load.json';
import enSharedFtue from '@flashka/shared/locales/en/en-ftue.json';
import enSharedFtueTopics from '@flashka/shared/locales/en/en-ftue-topics.json';
import enSharedKaWorking from '@flashka/shared/locales/en/en-ka-working.json';
import enSharedLegal from '@flashka/shared/locales/en/en-legal.json';
import enSharedOralExam from '@flashka/shared/locales/en/en-oral-exam.json';
import enSharedPageLoader from '@flashka/shared/locales/en/en-page-loader.json';
import enSharedProcessing from '@flashka/shared/locales/en/en-processing.json';
import enSharedQuizzes from '@flashka/shared/locales/en/en-quizzes.json';
import enSharedUpgrade from '@flashka/shared/locales/en/en-upgrade.json';

import enTranslation from '@/locales/en/en.json';
import enAuthTranslation from '@/locales/en/en-auth.json';
import enDashboardTranslation from '@/locales/en/en-dashboard.json';
import enEditorTranslation from '@/locales/en/en-editor.json';
import enFlashcardTranslation from '@/locales/en/en-flashcard.json';
import enFormsTranslation from '@/locales/en/en-forms.json';
import enGenericTranslation from '@/locales/en/en-generic.json';
import enHomeTranslation from '@/locales/en/en-home.json';
import enLandingTranslation from '@/locales/en/en-landing.json';
import enOnboardingTranslation from '@/locales/en/en-onboarding.json';
import enPdfTranslation from '@/locales/en/en-pdf.json';
import enPomodoroTranslation from '@/locales/en/en-pomodoro.json';
import enQuizTranslation from '@/locales/en/en-quiz.json';
import enSeoTranslation from '@/locales/en/en-seo.json';
import enUpgradeTranslation from '@/locales/en/en-upgrade.json';

const en = {
  ...enTranslation.translation,
  ...enAuthTranslation.translation,
  ...enPdfTranslation.translation,
  ...enPomodoroTranslation.translation,
  ...enFlashcardTranslation.translation,
  ...enGenericTranslation.translation,
  ...enHomeTranslation.translation,
  ...enLandingTranslation.translation,
  ...enUpgradeTranslation.translation,
  ...enSharedUpgrade.translation,
  ...enSharedOralExam.translation,
  ...enSharedQuizzes.translation,
  ...enSharedLegal.translation,
  ...enSharedCreateMenu.translation,
  ...enSharedDocumentLoad.translation,
  ...enSharedFtue.translation,
  ...enSharedFtueTopics.translation,
  ...enSharedConnection.translation,
  ...enSharedPageLoader.translation,
  ...enSharedProcessing.translation,
  ...enSharedKaWorking.translation,
  ...enSharedAccountSeed.translation,
  ...enDashboardTranslation.translation,
  ...enQuizTranslation.translation,
  ...enFormsTranslation.translation,
  ...enOnboardingTranslation.translation,
  ...enEditorTranslation.translation,
  ...enSeoTranslation.translation,
};

export default en;
